export const ICON_TAB_CLASS_NAME = 'kurama-IconTab'
